import { InlineLink } from "./InlineLink";

export const ShareSettingsTooltip = ({ text = "Learn more" }: { text?: string }) => <InlineLink target="_blank" href="https://authory.com/help/en/articles/9019811-share-settings-how-to-change-what-happens-if-visitors-click-on-your-portfolio-items">{text}</InlineLink>